import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addBrandCampaignSteps,
  getBrandCampaign,
  getSGPILists,
  getSingleBrandCampaignStep,
  GetSubAgendaType,
  UpdateBrandCampaignStep,
} from "./BrandCampaignRepo";
import { toast } from "react-toastify";
import { showToast } from "../../../utils/toastUtils";

interface paramsInterface {
  start?: number;
  length?: number;
  search?: string;
}

export const useGetBrandStepList = ({
  enable = false,
  params,
  id,
}: {
  enable: boolean;
  params: paramsInterface;
  id: number | null;
}) => {
  return useQuery({
    queryKey: ["BRAND_STEP_LIST", params, id],
    queryFn: () => getBrandCampaign(params, id),
    enabled: !!id && enable,
    retry: false,
  });
};

interface interfaceAgedaSubTye {
  Orgunitid: number | undefined;
  agendaType: string | undefined;
}

export const useGetAgendaSubType = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params: interfaceAgedaSubTye;
}) => {
  return useQuery({
    queryKey: ["LIST_SUB_AGENDA", params],
    queryFn: () => GetSubAgendaType(params),
    retry: false,
    enabled: enable,
  });
};

interface SGPIparamsIntreface {
  start: number;
  length: number;
  search?: string;
}

export const useGetSGPIList = ({
  enable = false,
  params,
}: {
  enable: boolean;
  params: SGPIparamsIntreface;
}) => {
  return useQuery({
    queryKey: ["SPI_LIST", params],
    queryFn: () => getSGPILists(params),
    enabled: enable,
    retry: false,
  });
};

interface ReqBody {
  VisitPlanId?: number;

  CampaignId: number | undefined;
  AgendaType: string;
  AgendaSubTypeId: number;
  StepLevel: number;
  StepName: string;
  Description: string;
  SgpiStatus: boolean | number;
  MonthYear: string;
  SgpiId: number[];
  CreateSurvey: boolean | number;
}

export const useAddBrandCampaignStep = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ReqBody: ReqBody) => addBrandCampaignSteps(ReqBody),
    onSuccess: (data: any) => {
      showToast.success("Added Step Successfully");
      queryClient.invalidateQueries({ queryKey: ["BRAND_STEP_LIST"] });
      queryClient.invalidateQueries({ queryKey: ["GET_SURVEY_QUESTION_LIST"] });
    },
    onError: (error: any) => {
      console.log("Failed to Add ", error.message);
      toast.error("Failed to Add", error.message);
    },
  });
};

export const useUpdateBrandCampaignStep = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ReqBody: ReqBody) => UpdateBrandCampaignStep(ReqBody),
    onSuccess: () => {
      showToast.success("Updated  Successfully");
      queryClient.invalidateQueries({ queryKey: ["BRAND_STEP_LIST"] });
    },
    onError: (error: any) => {
      console.log("Failed to update ", error.message);
      toast.error("Failed to update", error.message);
    },
  });
};

export const useGetSingleBrandCampaignStep = ({
  enable = false,
  id,
}: {
  enable: boolean;
  id: number | boolean;
}) => {
  return useQuery({
    queryKey: ["GET_SINGLE_BRAND_STEP", id],
    queryFn: () => getSingleBrandCampaignStep(id),
    retry: false,
    enabled: enable && !!id,
  });
};
